
export function removeItem(itemKey){
    window.localStorage.removeItem(itemKey);
}
export function getItem(itemKey){
    return window.localStorage.getItem(itemKey);
}
export function addItem(itemKey, newItem){
    window.localStorage.setItem(itemKey, newItem);
}